import { useContext, useState } from "react";
import IngenRegistreringer from "../../../person/id/IngenRegistreringer";
import TableBasic, { TableRow } from "../../../../Table/TableBasic";
import { defaultKursusKorrespondanceColumns } from "../../../../../config/kursusConfig";
import { TD, getHeaderActiveColumns } from "../../../../../util/table";
import DocumentModal from "../../../../Modal/modals/DocumentModal";
import OpenEmailIcon from "../../../../icons/OpenEmailIcon";
import { kursusKorrespondanceForm } from "../../../../../config/form/kursus/kursusKorrespondanceFormConfig";
import { KursusholdKorrespondance } from "../../../../../interfaces/schema";
import { KursusKorrespondanceField } from "../../../../../interfaces/kursus";
import { IColumn, SortBy } from "../../../../../interfaces/table";
import { UserQueryContext } from "../../../../../context/UserContext";
import { orderBy } from "../../../../../util/orderBy";

const KorrespondanceTable = ({
  kursusId,
  kursusKorrespondance,
  columns,
  setActiveColumns,
  invalidateData,
}: {
  kursusId: string;
  kursusKorrespondance: KursusholdKorrespondance[];
  columns: IColumn<KursusKorrespondanceField>[];
  setActiveColumns: React.Dispatch<
    React.SetStateAction<KursusKorrespondanceField[]>
  >;
  invalidateData: InvalidateDataFunction<any>;
}) => {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "KursusWrite");
  const [sortBy, setSortBy] = useState<SortBy[]>(defaultSortBy);
  if (!kursusKorrespondance.length) {
    return <IngenRegistreringer invalidateData={invalidateData} />;
  }
  return (
    <>
      <TableBasic
        defaultColumns={defaultKursusKorrespondanceColumns}
        columns={columns}
        setActiveColumns={setActiveColumns}
        headerRow={
          <>
            {getHeaderActiveColumns(columns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
            <th></th>
          </>
        }
      >
        {orderBy(
          kursusKorrespondance,
          sortBy.map((kk) => kk.field),
          sortBy.map((kk) => kk.direction),
        ).map((kk) => {
          const editConfig = kursusKorrespondanceForm(kursusId, kk.id);
          return (
            <TableRow
              key={kk.id}
              editConfig={canWrite ? editConfig : undefined}
              invalidateData={invalidateData}
            >
              <>
                {columns
                  .filter((col) => col.active)
                  .map((col) => (
                    <TD key={col.field} col={col} rowData={kk} />
                  ))}
              </>
              <td>
                {editConfig.getDocument && (
                  <DocumentModal
                    getDocument={editConfig.getDocument}
                    downloadLink={editConfig.downloadLink}
                    title={
                      <>
                        <OpenEmailIcon height={18} />
                        <span className="h3">
                          {kk.emne}
                          {/* <small className="text-secondary">
                          {kor.opretDato}
                        </small> */}
                        </span>
                      </>
                    }
                    buttonContents={[
                      <OpenEmailIcon key={1} />,
                      <span key={2}>Vis</span>,
                    ]}
                    contentProps={{
                      className: "c-document c-document--korrespondence",
                    }}
                  />
                )}
              </td>
            </TableRow>
          );
        })}
      </TableBasic>
    </>
  );
};
const defaultSortBy: SortBy<KursusKorrespondanceField>[] = [
  {
    direction: "desc",
    field: "sendt",
  },
];
export default KorrespondanceTable;
